// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledString from '../../../shared/components/labeled-string';
import PipDetails from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import PipLink from '../../shared/components/pip-link';
import {buildDate} from '../../../shared/services/build-date';

const PipProgramDetails = props =>
    <section className='pip-program-details'>
        <div className='row'>
            <LabeledString
                data={props.pipProduct.pipType.value}
                label='PIP_TYPE'
            />
            <LabeledString
                data={props.pipProduct.pipStatus.value}
                label='PIP_STATUS'
            />
            <LabeledString
                data={buildDate(props.pipProduct.expireDate)}
                label='EXPIRES'
            />
        </div>
        <div className='row'>
            <LabeledLink
                data={props.pipProduct.dtac}
                href={props.pipProduct.dtacUrl}
                label='DTAC_SOLUTION'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledString
                data={props.pipProduct.participant.value}
                label='PARTICIPANT'
            />
            <LabeledString
                data={buildDate(props.pipProduct.terminationDate)}
                label='TERMINATES'
            />
        </div>
        <div className='row'>
            <LabeledString
                data={props.pipProduct.pipNumber}
                label='PROGRAM_NUMBER'
            />
            <LabeledString
                data={props.pipProduct.metric.value}
                label='METRIC'
            />
        </div>
        <footer>
            <PipLink
                id={props.pipProduct.pipId}
                pipLinkStyle='primary'
                pipLinkText='VIEW_DETAILS'
            />
        </footer>
    </section>;

PipProgramDetails.displayName = 'PipProgramDetails';
PipProgramDetails.propTypes = {
    pipProduct: PropTypes.instanceOf(PipDetails).isRequired
};

export default PipProgramDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-program-details.js